import React from 'react';

const BRAND = 'Invozio';

/**
 * Hero heading for the auth pages: one confident display line where a single
 * part carries the violet gradient and the rest stays in ink.
 *
 * The emphasised part is the company name when the title contains it
 * ("Welcome to **Invozio**"), otherwise the closing word ("Welcome **back**",
 * "Välkommen **tillbaka**"). Both languages work without touching any copy.
 */
export const AuthHeroTitle: React.FC<{ title: string }> = ({ title }) => {
    const clean = title.trim();
    const at = clean.indexOf(BRAND);

    let lead = '';
    let accent = clean;
    let trailing = '';

    if (at !== -1) {
        lead = clean.slice(0, at);
        accent = BRAND;
        trailing = clean.slice(at + BRAND.length);
    } else {
        const lastSpace = clean.lastIndexOf(' ');
        if (lastSpace > 0) {
            lead = clean.slice(0, lastSpace + 1);
            accent = clean.slice(lastSpace + 1);
        }
    }

    return (
        <h1 className="auth-hero__title">
            <span className="auth-hero__kicker" aria-hidden="true" />
            {lead}
            <span className="auth-hero__accent">{accent}</span>
            {trailing}
        </h1>
    );
};

export default AuthHeroTitle;
